import { api } from './api';

export async function openPdf(path, filename = 'health-buddy.pdf') {
  const { data } = await api.get(path, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noreferrer';
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

export async function openFile(path, filename = 'health-buddy-file') {
  const requestPath = path.startsWith('/api/') ? path.slice(4) : path;
  const { data, headers } = await api.get(requestPath, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([data], { type: headers?.['content-type'] || 'application/octet-stream' }));
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noreferrer';
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}
